import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const WalletUserBalanceWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const BodyLoader = styled(ContentLoader)`
  background-color: ${({ theme }) => theme.colors.text.interactive};
  border-radius: ${({ theme }) => theme.borderRadius.high};
  height: 13.3rem;

  ${({ theme }) => theme.media.laptop`
    x: 0.1rem;
    y: 0.5rem;
    height: 5.8rem;
    width: 50rem;
  `};
`;

export const Amount = styled.rect`
  height: 3rem;
  width: 14rem;

  x: 8rem;
  y: 0;

  rx: ${({ theme }) => theme.borderRadius.low};
  ry: ${({ theme }) => theme.borderRadius.low};

  ${({ theme }) => theme.media.laptop`
    x: 0.1rem;
    y: 0.5rem;
    height: 2.4rem;
    width: 14rem;
  `};
`;

export const Change = styled.rect`
  height: 10.6rem;
  width: 25rem;

  x: 2.7rem;
  y: 3.7rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 0.1rem;
    y: 3.8rem;
    height: 1.6rem;
    width: 38rem;
  `};
`;
